import {
  language_item,
  logout_item,
  profile_item,
  support_item,
} from '../../../../../components/layout/ProfileDropdown';

export default {
  items: {
    [profile_item]: 'Profiel',
    [language_item]: 'Taal wijzigen',
    [support_item]: 'Support',
    [logout_item]: 'Uitloggen',
  },
};
